import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="px-4 md:px-10 py-12 md:py-16">
      <div className="max-w-[1280px] mx-auto">
        <div className="bg-foreground-900 rounded-3xl px-8 md:px-14 py-12 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <h3 className="text-white text-xl font-heading font-bold mb-6">
                GTBuy Garden
              </h3>
              <p className="text-white/50 text-sm leading-relaxed">
                Your gateway to smarter shopping through data-driven spreadsheet comparisons. Compare across GTBuy, Kakobuy, and Superbuy platforms.
              </p>
            </div>

            <div>
              <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">
                Categories
              </h3>
              <div className="grid grid-cols-2 gap-y-2 gap-x-4">
                {categories.map((cat) => (
                  <a
                    key={cat.name}
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-white/50 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                  >
                    {cat.name}
                  </a>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">
                Quick Links
              </h3>
              <div className="flex flex-col gap-2.5">
                <Link
                  to="/"
                  className="text-white/50 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  Home
                </Link>
                <Link
                  to="/article/gtbuy-spreadsheet-complete-guide"
                  className="text-white/50 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  Complete Guide
                </Link>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-white/50 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  Main Store
                </a>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-white/50 text-sm hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                >
                  GTBuy Sheet
                </a>
              </div>
            </div>

            <div>
              <h3 className="text-white text-sm font-semibold uppercase tracking-wider mb-5">
                Main Store
              </h3>
              <p className="text-white/50 text-sm mb-4">
                Visit our main store for the full product catalog and latest deals.
              </p>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center px-5 py-2.5 rounded-full text-sm font-semibold bg-primary-500 text-white hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                Buy It Now
                <i className="ri-arrow-right-up-line ml-1.5"></i>
              </a>
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/10">
            <p className="text-white/30 text-xs text-center leading-relaxed max-w-2xl mx-auto">
              We do not sell products directly. We provide structured comparison data only. Some links may contain affiliate tracking. All data is for informational purposes only.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}